module.exports = __webpack_public_path__ + "308e37cce.png";